import * as React from 'react'
import {
	DragSource,
	DragSourceMonitor,
	DragSourceConnector,
	ConnectDragSource,
	DragSourceSpec
} from 'react-dnd'
import UserImage from '../UserImage/index';


// export interface Props {
// 	isDragging?:boolean;
// 	data?:any;
// 	connectDragSource?:(jsx:JSX.Element)=> JSX.Element
// 	onDrop?:(dropResult:User)=>void
// }

let boxSource= {
	beginDrag(props) {
		return props;
	},
	endDrag(props, monitor) {
        const item = monitor.getItem();
		const dropResult = monitor.getDropResult();

		if (monitor.didDrop() && dropResult) {
			props.onDrop( dropResult );
		}
	}
}

let nodeSourceCollector = (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	isDragging: monitor.isDragging()
});

@DragSource('changeowner', boxSource, nodeSourceCollector)
export default class Sponsor extends React.Component {
	render()  {
		const { isDragging, connectDragSource } = this.props;
		const { data } = this.props;
		const opacity = isDragging ? 0.4 : 1;
		const visibility = isDragging ? "hidden":"visible";

		return connectDragSource(
            <div className="dragger_box ui-draggable" key={data.UserId} style={{visibility}}>
					 <UserImage profileUrl={data.ProfileImage}  profileName={data.FirstName+" "+data.LastName }/>
                <a href="javascript:void(0);" title={ data.FirstName + data.LastName }>{ data.FirstName +' '+ data.LastName }</a>
				<span className="role" title={data.JobTitle}>{data.JobTitle }</span>
                <span className="email" title={data.Email}>{data.Email}</span>
            </div>
        )
	}
}